import { useInteractions } from "@floating-ui/react";
import { createContext } from "react";

export type SelectContextValue = {
  activeIndex: number | null;
  selectedIndex: number | null;
  getItemProps: ReturnType<typeof useInteractions>["getItemProps"];
  handleSelect: (id: string, index: number | null) => void;
};

export const SelectContext = createContext<SelectContextValue>(
  {} as SelectContextValue,
);
